import template from './card-detail.html';
import controller from './card-detail.controller';

let cardDetailComponent = {
  bindings: {},
  template,
  controller
};

export default cardDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/card/card-detail.component.js